<template lang="pug">
.history-leaf(v-if="blok" v-editable="blok")
	h2.history-year {{ blok.year }}
	.history-content(v-if="blok.content")
		component(v-if="blok && richText" :is="{ template: richText, functional: true }")
</template>

<script setup lang="ts">
const props = defineProps({
	blok: {
		required: true,
		type: Object
	}
})
const richText = computed(() => renderRichText(props.blok.content, {
	resolver: (component, blok) => {
		return `<component :blok='${JSON.stringify(blok)}' is="${component}" />`
	}
}))
</script>

<style scoped lang="sass">
.history-leaf
	max-width: 445px
	border-radius: $radius-default
	padding: $spacing-24
	background: rgba(255, 255, 255, 0.08)
	box-shadow: 0px 4px 20px rgba(2, 26, 13, 0.5)
	margin-bottom: $spacing-48
	@media (min-width: $desktop)
		margin-bottom: 0
	.history-year
		@include fontSize(3xl)
		@include font(basier, bold)
		margin-bottom: $spacing-16
		color: $color-grey-40
	.history-content ul
		@include fontSize(m)
		@include font(basier, medium)
		list-style-type: disc
		padding-inline-start: 19px
		:deep(li p)
			display: inline
</style>
